import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); nav("/admin"); }
    catch (err) {
      setError(err.response?.status === 429 ? "Demasiados intentos. Espera unos minutos." :
        [401, 403].includes(err.response?.status) ? "Credenciales incorrectas." :
        "No se puede conectar con el servidor. Inténtalo de nuevo.");
    }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0C0C0C] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#2A2A2A] p-10">
        <div className="text-center mb-8">
          <div className="w-12 h-12 mx-auto border border-[#C9A55A] flex items-center justify-center mb-4">
            <span className="font-display text-[#C9A55A] text-xl">S</span>
          </div>
          <div className="text-overline text-[#C9A55A]">SLR · SLRC</div>
          <h1 className="font-display text-2xl text-[#F5F1EB] mt-2">{t.admin.login}</h1>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-[10px] text-[#8A8A8A] tracking-[0.18em] uppercase block mb-1">{t.admin.email}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required data-testid="admin-email-input"
              className="w-full bg-[#0C0C0C] border border-[#2A2A2A] focus:border-[#C9A55A] text-[#F5F1EB] px-3 h-11 text-sm" />
          </div>
          <div>
            <label className="text-[10px] text-[#8A8A8A] tracking-[0.18em] uppercase block mb-1">{t.admin.password}</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required data-testid="admin-password-input"
              className="w-full bg-[#0C0C0C] border border-[#2A2A2A] focus:border-[#C9A55A] text-[#F5F1EB] px-3 h-11 text-sm" />
          </div>
          {error && <div className="text-xs text-[#B8342A]" data-testid="admin-login-error">{error}</div>}
          <button type="submit" disabled={loading}
            className="btn-gold w-full disabled:opacity-50"
            data-testid="admin-login-submit">
            {loading ? "…" : t.admin.signin}
          </button>
        </form>
      </div>
    </div>
  );
}
